<template>
    <div style="position: relative;">
        <mymask :loaded="loaded"/>
        <myheader/>
        <div class="flex-section">
            <BrandIntro/>
            <ProductIntro/>
            <flowerList/>
        </div>
        <CardDownload/>
    </div>
</template>
<script>

import myheader from './header.vue';
import BrandIntro from './BrandIntro.vue';
import ProductIntro from './ProductIntro.vue';
import FlowerList from './FlowerList.vue';
import CardDownload from './CardDownload.vue';

import mymask from '../Mask.vue';


export default {
    data(){
        return {
            el: "test",
            loaded: false,
            w_width: 0
        }
    },
    components: {
        myheader,
        BrandIntro,
        ProductIntro,
        FlowerList,
        CardDownload,
        mymask
    },
    methods: {
		scroll_to(el){
			//product-intros

			let el_top =  (this.w_width>768)?($(el).offset().top):($(el).offset().top-50)
			
			

			$("HTML, BODY").animate({ scrollTop: el_top}, 500);
			
			
			

		},
		handleResize() {
			this.w_width = window.innerWidth;
		}
	},
    
    mounted(){
        console.log("index!!")
        console.log(this.w_width)
        console.log(this.$route.name)
        
        setTimeout(()=>{
            this.loaded = true;
            this.scroll_to("#"+this.$route.name);
            console.log($("#"+this.$route.name).offset().top);
        },500);
        
    },
	watch: {
        '$route' (to, from) {
            //console.log(123)
            if(this.$route.name == 'product-intro'){
                let x =setTimeout(()=>{
                    this.scroll_to("#product-intro");
                    clearTimeout(x)
                },500);
                // clearTimeout(x)
            }
            if(this.$route.name == 'brand-intro'){
                let x = setTimeout(()=>{
                    this.scroll_to("#brand-intro");
                    clearTimeout(x)
                },500);
                // 
                
            }
            if(this.$route.name == 'flower-list'){
                let x = setTimeout(()=>{
                    this.scroll_to("#flower-list");
                    clearTimeout(x)
                },500);
                // 
                
            }
            if(this.$route.name == 'card-download'){
                let x = setTimeout(()=>{
                    this.scroll_to("#card-download");
                    clearTimeout(x)
                },500);
                // 
                
            }
        }    
    },
	created() {
		window.addEventListener('resize', this.handleResize)
		this.handleResize();
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize)
	}
}
</script>
<style lang="sass">
.flex-section
    display: flex
    flex-wrap: wrap
    z-index: -100
    section
        width: 100%
    @media (max-width: 576px)
        section:nth-child(1)
            order: 2
        section:nth-child(2)
            order: 1
        section:nth-child(3)
            order: 3



</style>



// WEBPACK FOOTER //
// src/Index/index.vue